  // core version + navigation, pagination modules:
  import Swiper, { Navigation } from 'swiper';
  Swiper.use([Navigation]);
  import 'swiper/swiper-bundle.css'
  import 'swiper/modules/pagination/pagination.min.css'
  import 'swiper/modules/navigation/navigation.min.css'

let library = {
    'observer': function() {
        var opacityTargets = document.querySelectorAll('.is-opacity');
        let movingTargets = document.querySelectorAll('.is-move');
        let movingTargetsLtr = document.querySelectorAll('.is-move-ltr');
        let willBeFancy = document.querySelectorAll('.will-be-fancy');
        let willBeFancy2 = document.querySelectorAll('.will-be-fancy-2');
        let willBeTyped = document.querySelectorAll('.typed');

        let newTargets = [...opacityTargets, ...movingTargets, ...movingTargetsLtr];
        let animatedTargets = [...willBeFancy, ...willBeFancy2];
        let typingTargets = [...willBeTyped];

        const options = {
            root: null,
            rootMargin: '0px 20px 0px 30px',
            threshold: [0, 0.25, 0.75, 1]
        }
        
        observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if(entry.intersectionRatio > 0.5) {
                    entry.target.classList.add('fancy');
                    observer.unobserve(entry.target)
                }
            }) 
        }, options);

        observer2 = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                // const boundsRect = entry.boundingClientRect;
                if(entry.intersectionRatio > 0.5) {
                    // console.log(boundsRect.y)
                    entry.target.classList.add('fancy-dual-box');
                    observer.unobserve(entry.target)
                }
            })
        }, options);


        newTargets.forEach(myTarget => {
            observer.observe(myTarget)
        })
        animatedTargets.forEach(target => {
            observer2.observe(target)
        })

    },
    'swiper': function(bodyClass) {
        if(document.body.classList.contains(bodyClass)) {
              // init Swiper:
            const swiper1 = new Swiper('.swiper1', {
                  // Optional parameters
                    loop: true,
                    spaceBetween: 40,
                    grabCursor: true,
                    // centeredSlides: true,
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    },

                    // If we need pagination
                    pagination: {
                        el: '.swiper-pagination1',
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next1',
                        prevEl: '.swiper-button-prev1',
                    },

                    // And if we need scrollbar
                    scrollbar: {
                        el: '.swiper-scrollbar1',
                    },
                // configure Swiper to use modules
            });

            const swiper2 = new Swiper('.swiper2', {
                // Optional parameters
                  loop: true,
                  spaceBetween: 40,
                  grabCursor: true,
                // centeredSlides: true,
                  breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    },

                  // If we need pagination
                  pagination: {
                      el: '.swiper-pagination2',
                  },

                  // Navigation arrows
                  navigation: {
                      nextEl: '.swiper-button-next2',
                      prevEl: '.swiper-button-prev2',
                  },

                  // And if we need scrollbar
                  scrollbar: {
                      el: '.swiper-scrollbar2',
                  },
              // configure Swiper to use modules
          });

        const swiper3 = new Swiper('.swiper3', {
            // Optional parameters
            loop: false,
            spaceBetween: 40,
            grabCursor: true,
            // centeredSlides: true,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 3,
                },
                },

            // If we need pagination
            pagination: {
                el: '.swiper-pagination3',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next3',
                prevEl: '.swiper-button-prev3',
            },

            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar3',
            },
        // configure Swiper to use modules
        });

        }
    },
    // 'swiper': function(bodyClass) {
    //     if(document.body.classList.contains(bodyClass)) {
    //         let slideIndex = 0;
    //         let slides = document.getElementsByClassName("slider");
    //         if(slides !== null) {
    //             showSlides();
    //         }
    //         function showSlides() {
    //           let i;
    //           let slides = document.getElementsByClassName("slider");
    //           if(slides !== null) {
    //                 let pages = document.querySelectorAll(".slider-controls li");
    //                 let overlay = document.getElementById("overlay")
    //                 for (i = 0; i < slides.length; i++) {
    //                     slides[i].classList.contains("slide-active") ? slides[slideIndex-1].classList.toggle("slide-active") : '';
    //                     pages[i].classList.contains("active") ? pages[slideIndex-1].classList.toggle("active") : '';
    //                 }
    //                 slideIndex++;
    //                 if (slideIndex > slides.length) {slideIndex = 1}
    //                 if(slides){
    //                     console.log(slides)
    //                     slides[slideIndex-1].classList.toggle("slide-active");
    //                     pages[slideIndex-1].classList.toggle("active");
    //                     setTimeout(showSlides, (slides.length*2000)); // Change image every 2 seconds
    //                 }
    //             }
    //         }
    //     }
    // },
    'overlays': function() {
        let overlay1 = document.getElementById("overlay1")
        let overlay2 = document.getElementById("overlay2")
        let overlay3 = document.getElementById("overlay3")
        if(document.body.classList.contains('home')) {
            overlay1.style.width = '200%';
            overlay2.style.width = '200%';
            overlay3.style.width = '200%';
        }
    },
    'letters': function() {
        let letters = document.querySelectorAll('.hero--text-wrap span')
        let i
        let timer = 800
        
        letters.forEach(letter => {
            setTimeout(() => {
                letter.style.opacity = '1';
                letter.style.transform = 'scale(1)';
            },timer)
            timer+= 100
        });
    },
    'headroom': function() {
        let myElement = document.querySelector("header");
        let headroom  = new Headroom(myElement);
        headroom.init()
    },
    'toTop': () => {
        const btn = document.getElementById("btnToTop");
        window.onscroll = function() {scrollFunction()};
        function scrollFunction() {
            if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                if(btn !== null) {
                    btn.classList.remove("inactive");
                }
            } else {
                if(btn !== null) {
                    btn.classList.add("inactive");
                }
            }
        }
        function topFunction() {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            }
            if(btn !== null) {
                btn.addEventListener("click", () => {
                        topFunction()
                })
            }
    },
    'navigation': function() {
        /***
         * PC MENU
         */
        if(window.innerWidth >= 769) {
            const hasMenuLink = document.querySelectorAll(".has-menu")
            console.log(hasMenuLink)
            if(hasMenuLink !== null) {
                hasMenuLink.forEach(link => {
                    window.addEventListener('click', (e) => {
                        if(e.target !== 'a') {
                            hasMenuLink.forEach(l => l.classList.remove('is-active-menu'))
                        }
                    } )
                    link.addEventListener('mouseover', (e) => {
                        hasMenuLink.forEach(l => 
                            l.classList.remove('is-active-menu')
                        )
                        link.classList.toggle('is-active-menu')
                        // let hasMenuUl = document.querySelectorAll('li.is-active-menu ul li a')
                        // hasMenuUl.forEach(a => {
                        //     a.addEventListener('mouseout', () => {
                        //         console.log(a.parentElement.parentElement.parentElement.classList.remove('is-active-menu'))
                        //     })
                        // })                        
                        link.parentElement.addEventListener('mouseleave', (e) => {
                            console.log(link)
                            console.log(hasMenuLink)
                            document.querySelectorAll(".is-active-menu ul").forEach(ul => {
                                ul.style.opacity = 0
                                setTimeout(() => {
                                    ul.removeAttribute('style')
                                    link.classList.remove('is-active-menu')
                                }, 900)
                            })
                            // link.classList.toggle('is-active-menu')
                        })
                    })

                })
            }
        }

        /***
         * SP HAMBURGER MENU
        */
    //    if(window.innerWidth < 769) {
    //        const hamburger = document.querySelector('.hamburger')
    //        const secondaryLinks = document.querySelectorAll('a.second')
    //        if(hamburger !== null) {
    //            const hasMenuLink = document.querySelectorAll(".has-menu > a:first-of-type")  
    //            const activeMenuLinks = document.querySelectorAll(".is-active-menu + ul a")  
    //            hamburger.addEventListener('click', (e) => {
    //                document.querySelector('#barba-wrapper').classList.toggle('nav-is-active')
    //            })
    //            hasMenuLink.forEach(link => {
    //                 link.addEventListener('click', () => {
    //                     link.parentElement.classList.toggle('is-active-menu')
    //                 })
    //            })
    //            activeMenuLinks.forEach(link => {
    //             link.addEventListener('click', () => {
    //                 link.parentElement.parentElement.toggle('is-active-menu')
    //             })
    //            })
    //            secondaryLinks.forEach(link => {
    //                 link.addEventListener('click', () => {
    //                     document.querySelector('#barba-wrapper').classList.toggle('nav-is-active')
    //                 })
    //            })
    //         }
    //     }
        const hamburger = document.querySelector('.hamburger')
        hamburger.addEventListener('click', () => {
            document.body.classList.toggle('nav-is-active')
        })

        /***
         * SP Navigation panel
         */
        const subMenu = document.querySelector(".menu-sub");
        if(subMenu !== null) {
            subMenu.addEventListener("click", function() {
                document.body.classList.toggle('menu-is-open')
                const panel = document.querySelector(".submenu");
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }

    },
    'accordion': function() {
        if(window.innerWidth <= 600) {
            console.log(window.innerWidth)
            const firsts = document.querySelectorAll('li.first')
            firsts.forEach(el => {
                el.addEventListener('click', (e) => {
                    el.classList.toggle('active')
                    Array.from(el.parentNode.children).forEach(li => {
                        if(! li.classList.contains('first')) {
                            if(el.classList.contains('active')) {
                                li.style.maxHeight = '55px';
                                li.style.borderTop = "1px solid #707070";
                            }
                            else {
                                li.style.maxHeight = 0;
                                li.style.borderTop = "none";
                            }
                        }
                    })
                })
            })
        }
    },
    'bottomFixedNav': function() {
        const btnToTop = document.getElementById('btnToTop')
        const footer = document.getElementById('footer')
        const nav = document.querySelector('nav')
        window.addEventListener('scroll', () => {
            if(document.body.scrollHeight - window.scrollY <= window.innerHeight + footer.offsetHeight) {
                if(window.innerWidth <= 768) {
                    nav.style.bottom = footer.offsetHeight + 'px'
                    btnToTop.style.bottom = (btnToTop.offsetHeight + footer.offsetHeight + 20) + 'px'
                }
                else {
                    btnToTop.style.bottom = btnToTop.offsetHeight + 'px'
                }
            }
            else {
                if(window.innerWidth <= 768) {
                    nav.style.bottom = 0
                    btnToTop.style.bottom = (nav.offsetHeight + 10) + 'px'
                }
                else {
                    btnToTop.style.bottom = '20px'
                }
            }
        })
    },
    'contactCard': function() {
        const header = document.querySelector('.header')
        const nav = document.querySelector('nav')
        const card = document.querySelector('.header .contact')
        card.style.top = ((header.offsetHeight - card.offsetHeight) + nav.offsetHeight) + 'px'
        if(window.innerWidth < 1500) {
            card.style.top = 'auto'
            card.style.bottom = 0
        }
        if(window.innerWidth < 1100) {
            card.classList.add('card-is-out')
            card.style.top = '50%'
            card.style.bottom = 'auto'
        }
        window.addEventListener('scroll', () => {
            if(window.scrollY >= 10) {
                card.classList.add('card-is-out')
            }
            if(window.scrollY < 10) {
                // card.classList.remove('card-is-out')
                card.classList.remove('card-active')
            }
        })
        card.addEventListener('click', () => {
            card.classList.toggle('card-active')
        })
    

    },
    'newsAccordion': function() {
        const news = document.querySelector('.news')
        const newsContent = document.querySelector('.news-content p')
        const newsBtn = document.querySelector('.details a')
        newsContent.style.maxHeight = 0;
        newsBtn.addEventListener('click', () => {
            news.classList.toggle('news-is-close')
            if(news.classList.contains('news-is-close')) {
                newsContent.style.maxHeight = 0;
            }
            else {
                newsContent.style.maxHeight = newsContent.scrollHeight + "px";
            }
        })
    },
    'ghostAccordion': function() {
        let triggerCtn = document.querySelector(".careers-ctn")
        if(triggerCtn !== null) {
            let activeTrigger
            let triggers = document.querySelectorAll('.careers-ctn .left-title')
            let centers = document.querySelectorAll('.careers-ctn .center')
            let rights = document.querySelectorAll('.careers-ctn .right')

            if(triggers !== null) {
                triggers[0].classList.add('active')
                centers[0].classList.add('active')
                rights[0].classList.add('active')
            }

            triggers.forEach(trigger => {
                trigger.addEventListener('click', () => {
                    triggers.forEach(t => t.classList.remove('active'))
                    trigger.classList.add('active')
                    if(centers !== null) {
                        centers.forEach(center => {
                            center.classList.remove('active')
                            if(center.dataset.desc === trigger.dataset.id) {
                                center.classList.add('active')
                            }
                        })
                    }
                    if(rights !== null) {
                        rights.forEach(right => {
                            right.classList.remove('active')
                            if(right.dataset.img === trigger.dataset.id) {
                                right.classList.add('active')
                            }
                        })
                    }
                })
            })

        }
    },
    'homepage': function() {
        console.log('test homepage')
        this.observer()
        this.ghostAccordion()
        // this.overlays()
        // this.letters()
        // this.headroom()
        this.toTop()
        // this.newsAccordion()
        // this.bottomFixedNav()
        // if(window.innerWidth > 768) {
        //     this.contactCard()
        // }
        this.navigation()
        // this.accordion()
        this.swiper('home')
        this.swiper('page-template-default')
        // this.accordionNavSp()
    },
    'page': function() {
    //     console.log('test page')
        this.navigation()
        // this.swiper('page-template-default')
    //     this.headroom()
    //     this.toTop()
    //     this.observer()
    //     this.accordion()
    },
    'init': function() {
        this.homepage();
        // this.page();
    }
}



// if (document.body.classList.contains('home')) {
    library.init()
    console.log('First init')
// }